module.exports = __webpack_public_path__ + "img/mobile/BetBar/logo@1x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/BetBar/logo@1x.png
// module id = 184
// module chunks = 0